import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetEmployeeCheckIDsRequestSchema,
  TGetEmployeeCheckIDsResponseSchema,
} from "./getEmployeeCheckIDs.schema";

export const getEmployeeCheckIDs = (axios: IAxiosInstance) => {
  return async (params: TGetEmployeeCheckIDsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetEmployeeCheckIDsResponseSchema>
    >(`/api/employee-check-ids`, { params });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
